import { Questionnaire } from '@/typings/Questionnaire';

type AutofillType = NonNullable<Questionnaire.FieldCommon['autofill']>;

/*
 * Is an autofill that is run on the current questionnaire responses.
 */
const isInternalAutofill = (autofill: Pick<AutofillType, 'action'> | null): autofill is NonNullable<Questionnaire.FieldCommon['autofill']> => Boolean(autofill && autofill.action !== 'initial-values' && autofill.action !== 'fill-from-internal-data');

export default isInternalAutofill;
